export const phone = (value) => {
	if (!/([(+]*[0-9]+[()+. -]*)[^a-zа-яA-ZА-Я_]{5,}/i.test(value)) {
		return 'Please enter valid phone number';
	}
};
